export default "__VITE_PUBLIC_ASSET__4e73a965__"